
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipNoCommandGeneric as ObiOwnShipNoCommandGenericElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-no-command-generic.js';
 
 
 

 
 export const ObiOwnShipNoCommandGeneric = createComponent({
   react: React,
   tagName: 'obi-own-ship-no-command-generic',
   elementClass: ObiOwnShipNoCommandGenericElement,
   events: {
     
   }
  });
 
 